import { render } from "./CartPaymentBankwire.vue?vue&type=template&id=2c9f69c7"
import script from "./CartPaymentBankwire.vue?vue&type=script&lang=js"
export * from "./CartPaymentBankwire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__